/**
 * Auth feature configuration.
 *
 * `REQUIRE_EMAIL_VERIFICATION` gates whether email/password users must verify
 * their email before reaching protected routes. Google sign-ins always arrive
 * `emailVerified=true`, so this only ever affects password accounts.
 *
 * Sourced from the CRA build-time env var `REACT_APP_REQUIRE_EMAIL_VERIFICATION`
 * (see `googleMaps.ts` for the same pattern). It is **build-time**, not runtime:
 * flipping it requires a rebuild/redeploy, not a live toggle. Defaults to `false`
 * (verification disabled) when unset. To require verification in an environment,
 * set the var to the string `'true'` in that environment's `.env`.
 */
export const REQUIRE_EMAIL_VERIFICATION =
    process.env.REACT_APP_REQUIRE_EMAIL_VERIFICATION === 'true';
